export const wc = t => { const m = (t || '').trim().match(/\S+/g); return m ? m.length : 0; };
export const fmt = n => n.toLocaleString('en-US');
export const spaceWords = sp => sp.docs.reduce((a, d) => a + wc(d.content), 0);
export const goalPct = sp => (sp && sp.goal > 0 ? Math.min(100, Math.round(spaceWords(sp) / sp.goal * 100)) : 0);
export const readTime = words => (words ? Math.max(1, Math.round(words / 220)) + ' min read' : 'Nothing yet — just start.');
export const docLabel = sp => (sp && sp.id === 'journal' ? 'entry' : 'document');
